<template>
  <div v-if="likebox" class="Mw-PostLogin-thankyou-like-box">
    <div
      v-if="showLikeBox"
      id="fb-page"
      class="fb-page"
      :data-href="url"
      data-hide-cover="false"
      data-show-facepile="true"
      data-show-posts="false"
    />
  </div>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      option: {
        type: Array,
      },
    },
    data() {
      return {
        showLikeBox: true,
      }
    },
    computed: {
      likebox() {
        const actionName = 'Like Box'
        return this.option.find((a) => a.action === actionName)
      },
      url() {
        if (
          this.likebox &&
          this.likebox.url &&
          (this.likebox.url.includes('https://') || this.likebox.url.includes('http://'))
        ) {
          return this.likebox.url
        }
        if (this.likebox && this.likebox.url) {
          return 'https://facebook.com/' + this.likebox.url
        }
      },
    },
    watch: {
      url() {
        if (typeof FB !== 'undefined') {
          FB.XFBML.parse()
          this.checkFBLike(this)
        }
      },
    },
    mounted() {
      this.mountFB()
      this.checkFBLike(this)
    },
    methods: {
      mountFB() {
        window.fbAsyncInit = function () {
          FB.init({ xfbml: true, version: 'v2.4' })
        }
        ;(function (d, s, id) {
          let js
          const fjs = d.getElementsByTagName(s)[0]
          if (d.getElementById(id)) {
            return
          }
          js = d.createElement(s)
          js.id = id
          js.src = '//connect.facebook.net/en_US/sdk.js'
          fjs.parentNode.insertBefore(js, fjs)
        })(document, 'script', 'facebook-jssdk')
      },
      checkFBLike: _.debounce(($vm) => {
        $vm.$nextTick(() => {
          if (typeof FB !== 'undefined') {
            if (window && window.fbAsyncInit) {
              FB.XFBML.parse()
            }
          }
        })
      }, 500),
    },
  }
</script>

<style scoped lang="scss">
  .Mw-PostLogin-thankyou-like-box {
    padding: 20px 0;
    img {
      max-width: 100%;
    }
  }
</style>
